import PropTypes from 'prop-types';
import { Component } from 'react';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes';
// @ts-expect-error Legacy code isn't typed.
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import I18n from 'I18n';
import classNames from 'classnames';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import refObject from 'UIComponents/utils/propTypes/refObject';
import UIMicroDateInput from 'UIComponents/dates/UIMicroDateInput';
import { getRelativeDateTimeValue } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
function toTimestamp(momentType, type, simpleDate) {
  if (!simpleDate) {
    return null;
  }
  if (type === 'date') {
    return SimpleDate.toMomentUTC(simpleDate).valueOf();
  } else {
    let result;
    if (momentType === MomentTypes.PORTAL) {
      result = SimpleDate.toMomentPortalTz(simpleDate);
    } else {
      result = SimpleDate.toMoment(simpleDate);
    }
    if (type === 'endOfDay') {
      result = result.endOf('day');
    }
    return result.valueOf();
  }
}
function toMoment(momentType, type, valueProp) {
  let value;
  if (valueProp || valueProp === 0) {
    value = Number(valueProp);
    if (isNaN(value)) {
      return null;
    }
  } else {
    return null;
  }
  if (type === 'date') {
    return I18n.moment.utc(value);
  }
  switch (momentType) {
    case MomentTypes.PORTAL:
      return I18n.moment.portalTz(value);
    case MomentTypes.USER:
      return I18n.moment.userTz(value);
    case MomentTypes.MOMENT:
      return I18n.moment(value);
    default:
      return null;
  }
}
export default class CRMPropertyDateInput extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = evt => {
      const {
        onChange,
        momentType,
        type
      } = this.props;
      const timestamp = toTimestamp(momentType, type, evt.target.value // 'as unknown as SimpleDate | null' is required because UIDateInput types onChange as `React.ChangeEvent<HTMLInputElement>` but actually broadcasts a `SyntheticEventType<SimpleDate | null>`
      );
      if (typeof onChange === 'function') {
        onChange(SyntheticEvent(timestamp));
      }
    };
  }
  getCommonInputProps() {
    const {
      className,
      inputRef
    } = this.props;
    return Object.assign({}, getTransferrableProps(this.props), {
      className: classNames('crm-property-date-input', className),
      inputRef,
      onChange: this.handleChange,
      // HACK: prevent ESC key presses from propagating up and cancelling changes
      // See https://git.hubteam.com/HubSpot/UIComponents/issues/9877
      onKeyDown: _stopPropagation,
      onKeyPress: _stopPropagation,
      onKeyUp: _stopPropagation
    });
  }
  getValue() {
    const {
      momentType,
      type,
      value
    } = this.props;
    const moment = toMoment(momentType, type, value);
    if (moment) {
      return SimpleDate.fromMoment(moment);
    }
    return null;
  }
  render() {
    const {
      inputSize,
      showRelativeDateValue
    } = this.props;
    const relativeDateValue = showRelativeDateValue && getRelativeDateTimeValue({
      value: `${this.props.value}`,
      isDate: this.props.type === 'date'
    });
    const format = relativeDateValue ? `L [(${relativeDateValue})]` : `L`;
    switch (inputSize) {
      case 'small':
        return (
          /*#__PURE__*/
          // @ts-expect-error UIMicroDateInput generated type is incorrect, as it does not omit React.AllHTMLAttributes<HTMLInputElement>['value'] from the union.
          // Also, does not allow passing static text in the format string
          _jsx(UIMicroDateInput, Object.assign({
            "data-test-id": "micro-date-input"
          }, this.getCommonInputProps(), {
            format: format,
            value: this.getValue()
          }))
        );
      case 'large':
      default:
        return /*#__PURE__*/_jsx(UIDateInput, Object.assign({
          "data-test-id": "date-input"
        }, this.getCommonInputProps(), {
          value: this.getValue()
          // @ts-expect-error UIDateInput does not allow passing static text in the format string
          ,
          format: format
        }));
    }
  }
}
CRMPropertyDateInput.propTypes = {
  className: PropTypes.string,
  inputRef: refObject,
  momentType: PropTypes.oneOf([MomentTypes.USER, MomentTypes.PORTAL, MomentTypes.MOMENT]),
  onChange: PropTypes.func,
  inputSize: PropTypes.oneOf(['small', 'large']),
  type: PropTypes.oneOf(['default', 'date', 'endOfDay']),
  showRelativeDateValue: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
CRMPropertyDateInput.defaultProps = {
  momentType: MomentTypes.USER,
  inputSize: 'large',
  type: 'default'
};
function _stopPropagation(e) {
  e.stopPropagation();
}